<style lang="scss" scoped>
.modal-container {
    width: 100vw;
    height: 100vh;
    position: fixed;
    pointer-events: none;
    top: 0;
    left: 0;
    z-index: 10000;
    transition: all 0.15s;

    .modal {
        position: absolute;
        display: flex;
        flex-direction: column;
        width: 1024px;
        left: 50%;
        height: 768px;
        opacity: 0;
        top: 50%;
        max-width: 100vw;
        transform: translate(-50%, -50%);
        background: #fff;
        transition: all 0.15s ease-in-out;
        overflow-y: auto;
        overflow-x: hidden;
        border-radius: 4px;

        .close {
            position: absolute;
            width: 12px;
            height: 12px;
            right: 26px;
            top: 26px;
            cursor: pointer;

            &:before,
            &:after {
                content: '';
                position: absolute;
                width: 14px;
                height: 1px;
                border-radius: 1px;
                left: 0;
                transform-origin: left;
                transition: background 0.15s ease-in-out;
                background-color: #000;
            }

            &:before {
                top: 1px;
                transform: rotate(45deg);
            }

            &:after {
                bottom: 0;
                transform: rotate(-45deg);
            }

            &:hover {
                &:before,
                &:after {
                    background-color: #000;
                }
            }
        }

        .modal-content {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
        }
    }
}

body.modal-active {
    .modal-container.show {
        pointer-events: all;
        background-color: rgba(27, 28, 31, 0.24);
        backdrop-filter: blur(5px);

        .modal {
            opacity: 1;
        }
    }
}

.component-fade-enter-active,
.component-fade-leave-active {
    transition: opacity 0.2s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>

<template>
    <div class="modal-container" @click="toggleModal" :class="{ show: show }">
        <div class="modal" :style="`width: ${width}px; height: ${height}px;`" @click.stop>
            <div class="close" @click="toggleModal"></div>
            <div class="modal-content" v-if="show">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import { bus } from '@/app';

export default {
    name: 'Ui.Modal',

    props: {
        name: {
            type: String,
            required: true,
        },
        width: {
            type: Number,
            required: false,
            default: 1024,
        },
        height: {
            type: Number,
            required: false,
            default: 768,
        },
    },

    data() {
        return {
            show: false,
        };
    },

    created() {
        const self = this;

        bus.$on('modal', name => {
            if (self.name === name) {
                self.show = true;
            }
        });

        bus.$on('modal-close', () => {
            this.toggleModal();
        });

        this.$on('close', value => {
            self.toggleModal();
        });
    },

    methods: {
        toggleModal() {
            this.$root.modalIsOpen = !this.$root.modalIsOpen;
            this.show = false;

            window.setTimeout(() => {
                bus.$emit('shopping-basket-message', '');
            }, 300);
        },
    },

    watch: {
        show() {
            document.getElementsByTagName('body')[0].classList.toggle('modal-active');
        },
    },
};
</script>
